import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MdbTableModule } from 'mdb-angular-ui-kit/table';
import { FrattaleService } from 'src/app/services/frattale.service';

@Component({
  selector: 'app-preferiti',
  standalone: true,
  templateUrl: './preferiti.component.html',
  styleUrls: ['./preferiti.component.scss'],
  imports: [MdbTableModule, CommonModule]
})
export class PreferitiComponent implements OnInit {

  tableData: any = []
  loadingData: boolean = false;
  headers = ['market', 'verso', 'swing', 'dayweek', 'num profit', 'profit', 
  'profit retr', 'profit bt euro', 'profit retr euro', 'preferito']
  
  constructor(private service: FrattaleService) { }

  ngOnInit(): void {
    this.service.dbangPreferiti().subscribe((res: any) => {
      console.log(res)
      let d = res['data'].map((item: any) => {
        item.preferito = item.preferito == null ? 'nessuno' : item.preferito
        return item
      })
      this.tableData = d
      console.log(d)
    })
  }

  updatePreferito(data: any, event: any){
    console.log(data, event.target.value)
    data.preferito = event.target.value
    this.service.dbangSavePreferiti(data).subscribe((res: any) => {
      console.log(res)
    })
  }
}
